module.exports = __webpack_public_path__ + "static/media/areas-icon.adbce80e.svg";